export const ApiUrl = {
    user : 'api/users'
}